<script>
	import { onMount, createEventDispatcher, tick } from "svelte";
	import { vehicleStatusLabel } from "src/utils/misc";

	export let categoryName = "";
	export let refetch = () => {};
	export let id = 0;
	export let idx = 0;
	export let options = [];
	export let toggle = () => {};
	export let isOpen = true;
	export let value = 0;
	export let handleSelect = () => {};
	export let chevron = true;
	export let alignRight = false;
	export let alignLeft = false;
	export let noElipsis = true;

	$: selected = options.find((option) => option.id === value) || {};

	$: selectedText = vehicleStatusLabel(selected);

	let hasMounted = false;

	const dispatch = createEventDispatcher();
	let menuEl;

	// if dropdown open, wait for it to render, then send its rect
	$: if (isOpen) {
		tick().then(() => {
			if (menuEl) {
				const rect = menuEl.getBoundingClientRect();
				dispatch("menuRect", rect);
			}
		});
	}

	function handleClickOutside(event) {
		if (!event.target.closest(".dropdown")) {
			isOpen = false;
		}
	}

	async function handleClick(value) {
		try {
			const res = await handleSelect(id, value.id);
			if (res.status === 200) {
				selected = value;
				if (value.substatus) {
					selectedText = value.status + " - " + value.substatus;
				} else {
					selectedText = value.status;
				}
			}

			toggle();
		} catch (error) {
			extractErrorMessage(error);
		}
	}

	onMount(() => {
		hasMounted = true;
		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	});
</script>

<div class="dropdown">
	<button
		class={`form-select getgo select dc-text dropdown-container ${
			chevron ? "" : "no-chevron"
		} ${alignRight ? "align-right" : ""} ${alignLeft ? "align-left" : ""}`}
		on:click={toggle}
	>
		<span
			class={`dropdown-option ` +
				(selected.status === "Active" ? "active" : "inactive")}
			style={`display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; ${
				noElipsis ? "" : "max-width: 180px"
			}`}
			title={selectedText}
		>
			{selectedText.toUpperCase()}
		</span>
	</button>
	{#if isOpen}
		<div class="dropdown-menu" bind:this={menuEl}>
			{#each options as option}
				<div
					class="dropdown-option-container"
					on:click={() => handleClick(option)}
					on:keydown={() => {}}
				>
					<span
						class={`dropdown-option ` +
							(option.status === "Active"
								? "active"
								: "inactive")}
					>
						{vehicleStatusLabel(option).toUpperCase()}
					</span>
				</div>
			{/each}
		</div>
	{/if}
</div>

<style>
	.active {
		background-color: #248a3d !important;
		width: fit-content;
	}
	.inactive {
		background-color: #d60c0c !important;
	}
	.dropdown {
		width: 100%;
		position: relative;
		display: inline-block;
	}

	.dropdown-menu {
		display: block;
		position: absolute;
		background-color: white;
		box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
		padding: 12px 16px;
		z-index: 1;
		width: max-content;
	}

	.dropdown-menu:hover {
		cursor: pointer;
	}

	.dropdown-option-container {
		height: 48px;
		display: flex;
		align-items: center;
	}

	.dropdown-option {
		border-radius: 8px;
		padding: 4px 14px;
		color: white;
		display: block;
	}

	label {
		display: block;
		margin-bottom: 8px;
	}

	.dropdown-item {
		height: 48px;
		width: 200px;
		display: flex;
		align-items: center;
	}

	.checkbox-item {
		margin-right: 8px;
	}

	.dc-text {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: var(--fds-on-surface-variant);
	}

	.getgo.select.dropdown-container {
		border: none !important;
		background-color: transparent !important;
	}

	.no-chevron {
		background-image: none !important;
	}

	.align-right {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.align-left {
		padding: 0 !important;
	}
</style>
